<template>
    <v-row justify="center">     
      <v-card width="100%" flat>
        <!-- <v-card-title>
          <span class="headline">Client Logo</span>
        </v-card-title> -->
        <v-card-text>
          <v-container>
            <v-row v-if="showUpload || !isEdit" align="start" justify="left">
              <v-col v-show="media.length === 0 " cols="12" sm="12" md="4" lg="4">
                <div style="margin-bottom:10px;font-size:14px;font-weight:400;">Client Logo</div>
                <v-responsive :aspect-ratio="1">
                    <v-card
                    outlined
                    flat
                    rounded
                    style="height: 100%"
                    class="d-flex"
                    @click="$refs.mediaUpload.click()"
                    >
                        <v-btn dark icon class="ma-auto" x-large>
                            <v-icon dark color="primary">mdi-cloud-upload</v-icon>
                        </v-btn>
                        <input
                            type="file"
                            name="images"
                            style="display: none"
                            ref="mediaUpload"
                            id="fileToUpload"
                            accept="image/*"
                            @change="prepareUpload"
                        />
                    </v-card>
                </v-responsive>
                <div v-show="isEdit" style="width:100%;text-align: center; margin-top: 20px;">
                  <v-btn text color="secondary" @click="showUpload = false">
                    Cancel
                  </v-btn>
                </div>
              </v-col>
              <v-col v-for="(img, index) in media" :key="index" cols="12" sm="12" md="6" lg="6">                
                <v-hover v-slot:default="{ hover }">           
                <v-card flat class="mx-auto" :elevation="hover ? 16 : 2">            
                <v-img
                    :src="img.preview.thumbnail"
                    :lazy-src="img.preview.thumbnail"                                              
                    class="grey lighten-2"
                ></v-img>                
                <!-- <v-overlay absolute >
                    <v-btn dark icon @click="deleteImage(index)">
                    <v-icon dark color="red">cancel</v-icon>
                    </v-btn>
                </v-overlay>              -->
                </v-card>                                             
                </v-hover>
                <div style="width:100%; text-align:center;">
                  <v-btn dark icon @click="deleteImage(index)">
                    <v-icon dark color="red">cancel</v-icon>
                  </v-btn>
                </div>
                          
              </v-col>
            </v-row>
            
            <v-row v-else align="start" justify="left">
              <v-col v-if="logoURI !== null && logoURI !== ''" cols="12" sm="12" md="6" lg="6">                  
                  <v-img                     
                    :src="logoURI"                                                 
                    :lazy-src="logoURI"
                    cover                    
                    class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <div v-show="isEdit" style="width:100%; text-align:center;">
                  <v-btn dark icon @click="showUpload = true">
                    <v-icon dark color="info">mdi-pencil</v-icon>
                  </v-btn>
                </div> 
              </v-col>
              <v-col v-else cols="12" sm="12" md="6" lg="6">
                   <v-img 
                    lazy-src="/static/img/upload-post-photo.png"
                    src="/static/img/upload-post-photo.png"                                                 
                    cover                    
                    class="grey lighten-2"
                ></v-img>
                <div v-show="isEdit" style="width:100%; text-align:center;">
                  <v-btn dark icon @click="showUpload = true">
                    <v-icon dark color="info">mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>            
          </v-container>          
        </v-card-text>        
      </v-card>    
  </v-row>
</template>
<script>
import Jimp from 'jimp';
import utils from '@/utils';
export default {
  name: 'upload-media',
  props: {
    accept: String,
    listMedia: Array,
    logoURI: String,
    isEdit: Boolean
  },
  data() {
    return {
      media: [],
      previewMedia: '',
      showUpload: false
    }
  },
  watch: {
    media(newValue) {
      this.$emit('change', newValue);
    },
    listMedia(value) {
      this.media = value
    }
  },
  methods: {
    prepareUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        // console.log('🚀 ~ file: UploadMedia.vue ~ line 111 ~ prepareUpload ~ element', element)
        let type = element.type.split('/')[0];
        if (type !== 'video' && type !== 'image') {
          return this.$swal('File Type Not Supported, Please select a video or an image');
        }
        // if (type === 'video') {
        //   if (element.size > 104857600) {
        //     let fileSize = element.size / (1024 * 1024)
        //     return this.$swal({
        //       title: 'File size',
        //       text: `Too big, maximum is 100MB. You file size is: ${fileSize.toFixed(2)} MB`,
        //       type: 'warning'
        //     });
        //   }
        //   return this.processVideo(element);
        // } else {
        this.processImage(element);
        // }
      });
    },
    processImage(image) {
      try {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e => {
          let buffer = e.target.result;
          Jimp.read(buffer, (err, img) => {
            if (err) console.error(111, err);
            img
              .resize(500, Jimp.AUTO)
              .quality(100)
              .getBase64(Jimp.MIME_PNG, (err, buff) => {
                if (err) console.error(222, err);
                let file = utils.func.dataURLtoFile(buff, image.name);
                this.media.push({
                  file,
                  preview: {
                    thumbnail: buff,
                    src: buff,
                    name: image.name
                  }
                });
              });
          });
        };
      } catch (error) {
        console.error(error);
        this.$swal({
          text: 'Error When processing iamge',
          type: 'error'
        });
      }
    },
    // viewMedia(media) {
    //   this.imageDialog = true
    //   if (media.file.type.indexOf('image') !== -1) {
    //     this.mediaType = 'image'
    //     this.previewMedia = media.preview.src
    //   } else {
    //     this.mediaType = 'vdo'
    //     setTimeout(() => {
    //       let video = document.getElementById('postVdo')
    //       let file = media.file;
    //       let blobURL = URL.createObjectURL(file);
    //       video.src = blobURL
    //       if (media.file.type.indexOf('mp4') !== -1) {
    //         video.type = 'video/mp4'
    //       } else if (media.file.type.indexOf('quicktime') !== -1) {
    //         video.type = 'video/quicktime'
    //       }
    //       video.load()
    //     }, 700)
    //   }
    // },
    deleteImage(imgIndex) {
      this.showUpload = false;
      this.media.splice(imgIndex, 1);
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?86e55c60